<div class="page">
  <div class="page_card" *ngIf="!calendarService.activityOpen">
    <header class="card_header static_card_header f--overflow-visible">
      <div class="tabs">
        <div class="tab tab--active">
          {{ 'common.calendar' | translate }}
        </div>
      </div>
      <div class="card_header-controls">
        <div class="month-header">
          <button class="month-header-button" (click)="switchMonth(-1)">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.7051 8.20492L11.1251 12.7949L15.7051 17.3849L14.2951 18.7949L8.29508 12.7949L14.2951 6.79492L15.7051 8.20492Z"/>
            </svg>
          </button>
          <span *ngIf="mobile.isMobile">
            {{currentMonth | date: 'MMM, y': null : translate.currentLang | titlecase}}
          </span>
          <span *ngIf="mobile.isDesktop">
            {{currentMonth | date: 'MMMM, y': null : translate.currentLang | titlecase}}
          </span>
          <button class="month-header-button" (click)="switchMonth(1)">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.29492 17.3849L12.8749 12.7949L8.29492 8.20492L9.70492 6.79492L15.7049 12.7949L9.70492 18.7949L8.29492 17.3849Z"/>
            </svg>
          </button>
        </div>
        <div class="card_header-actions" *ngIf="PROFILE_TYPES.TRAINER_TYPE">
          <div class="card_header-actions-settings">
            <div class="card_header-actions-settings-button" (click)="toggleSettings()">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M33.2512 18.5198C33.209 18.145 32.772 17.8633 32.394 17.8633C31.1721 17.8633 30.0878 17.1458 29.6331 16.0363C29.1685 14.8998 29.4681 13.5744 30.3787 12.7391C30.6654 12.4771 30.7002 12.0384 30.4598 11.7337C29.8344 10.9396 29.1236 10.2222 28.3475 9.60049C28.0435 9.35661 27.5976 9.39054 27.3341 9.68235C26.5393 10.5625 25.1117 10.8896 24.0086 10.4294C22.8606 9.94647 22.1367 8.78322 22.2075 7.53455C22.2308 7.14233 21.9442 6.80132 21.5531 6.75577C20.5572 6.64058 19.5524 6.63701 18.5535 6.74784C18.1669 6.7905 17.8802 7.12348 17.8932 7.51073C17.9367 8.74711 17.2041 9.89001 16.0675 10.3556C14.9775 10.8007 13.5599 10.4764 12.7668 9.60406C12.5046 9.31672 12.066 9.2814 11.7605 9.51943C10.9614 10.1464 10.2346 10.8643 9.60347 11.652C9.3573 11.9581 9.39351 12.4019 9.68304 12.6654C10.6111 13.5058 10.9107 14.8426 10.4286 15.9922C9.9683 17.0882 8.83023 17.7945 7.52735 17.7945C7.10457 17.7809 6.80343 18.0647 6.75719 18.4491C6.63991 19.4508 6.63852 20.4715 6.75144 21.4813C6.79331 21.8577 7.24367 22.137 7.62578 22.137C8.78687 22.1073 9.90163 22.8261 10.3693 23.9641C10.8354 25.1005 10.5358 26.4251 9.62371 27.2611C9.33844 27.5232 9.30223 27.9611 9.54264 28.2658C10.1622 29.0549 10.8731 29.773 11.652 30.3998C11.9575 30.646 12.402 30.6113 12.6668 30.3195C13.4646 29.4371 14.8921 29.1106 15.9909 29.5718C17.1417 30.0532 17.8657 31.2163 17.7948 32.4657C17.7717 32.8581 18.0597 33.1997 18.4492 33.2446C18.9587 33.304 19.4713 33.3337 19.9852 33.3337C20.4731 33.3337 20.9611 33.3069 21.449 33.2526C21.8356 33.2099 22.1221 32.877 22.1091 32.489C22.0643 31.2533 22.7983 30.1104 23.9334 29.6457C25.0307 29.1975 26.4423 29.5255 27.2356 30.397C27.4992 30.6837 27.9348 30.7183 28.2419 30.4811C29.0395 29.8556 29.7648 29.1383 30.399 28.3485C30.645 28.043 30.6103 27.5985 30.3193 27.3352C29.3913 26.4948 29.0901 25.1577 29.5722 24.0089C30.0255 22.9275 31.1213 22.2014 32.3 22.2014L32.4649 22.2057C32.8472 22.2368 33.1989 21.9423 33.2452 21.5521C33.3627 20.5494 33.3641 19.5297 33.2512 18.5198ZM20.0224 24.4759C17.5699 24.4759 15.5749 22.481 15.5749 20.0285C15.5749 17.5761 17.5699 15.5811 20.0224 15.5811C22.4749 15.5811 24.4699 17.5761 24.4699 20.0285C24.4699 22.481 22.4749 24.4759 20.0224 24.4759Z"></path>
              </svg>
            </div>
            <div class="card_header-actions-settings-body"
                 *ngIf="showSettings"
                 [@fadeInOut]
                 [formGroup]="restTimeForm">
              <div class="overlay" (click)="toggleSettings()"></div>
              <div class="description">
                <div class="header">{{'calendar.restTime' | translate}}</div>
                <div class="text">{{'calendar.restTimeDescription' | translate}}</div>
              </div>
              <app-material-input formControlName="rest_time_minutes"
                                  #restTime
                                  [label]="'calendar.setYourRestTime' | translate"
                                  [errors]="{
                                    'min': 'common.errors.min' | translate:{'number': SESSION.REST_TIME_MINUTES_MIN},
                                    'max': 'common.errors.max' | translate:{'number': SESSION.REST_TIME_MINUTES_MAX},
                                    'required': 'common.errors.required' | translate,
                                    'pattern': 'common.errors.numbersOnly' | translate
                                  }">
              </app-material-input>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="page_content" #card>
      <div class="month month--prev" #prevMonthEl>
        <app-month-view [currentMonth]="prevMonth">

        </app-month-view>
      </div>

      <div class="month month--current" #currentMonthEl>
        <app-month-view [currentMonth]="currentMonth">

        </app-month-view>
      </div>

      <div class="month month--next" #nextMonthEl>
        <app-month-view [currentMonth]="nextMonth">

        </app-month-view>
      </div>

    </div>
    <!--todo: this should be remade with ComponentFactoryResolver-->

  </div>
  <app-material-activity *ngIf="selectedTimeRange">
    <app-material-activity-header>
      <button class="back" (click)="closeSchedule()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z"/>
        </svg>
      </button>
      <span class="back-text">
        {{'calendar.setWorkingHours' | translate}}
      </span>
    </app-material-activity-header>
    <app-schedule-modal [selectedTimeRange]="selectedTimeRange"></app-schedule-modal>
  </app-material-activity>

  <app-material-activity *ngIf="selectedDay">
    <app-material-activity-header>
      <button class="back" (click)="toggleDayView()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.3333 5.33329H3.21996L6.94663 1.60663L5.99996 0.666626L0.666626 5.99996L5.99996 11.3333L6.93996 10.3933L3.21996 6.66663H11.3333V5.33329Z" fill="#F11C48"/>
        </svg>
      </button>
      <div class="date">
          <span class="date-title">
            {{selectedDay | date: 'MMMM, dd EEEE': null : translate.currentLang}}
          </span>
      </div>
    </app-material-activity-header>
    <app-day-view [date]="selectedDay">

    </app-day-view>
  </app-material-activity>

  <app-material-activity *ngIf="selectedSession">
    <app-material-activity-header>
      <button class="back" (click)="closeSession()">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z"
            fill="#3C474B"/>
        </svg>
      </button>
      <span class="back-text">
        {{'events.trainingSession' | translate}}
      </span>
    </app-material-activity-header>
    <app-training-view [data]="selectedSession">

    </app-training-view>
  </app-material-activity>

  <app-material-activity *ngIf="selectedEvent">
    <app-material-activity-header class="two-line-header">
      <button class="back" (click)="closeSession()">
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z"
            fill="#3C474B"/>
        </svg>
      </button>
      <span class="back-text">
        {{'events.event' | translate}}
      </span>
    </app-material-activity-header>
    <app-event-view class="two-line-header-tabs" [data]="selectedEvent">

    </app-event-view>
  </app-material-activity>
</div>
